import { Timestamp } from 'firebase/firestore'

export type AgentName = 'scout' | 'archivist' | 'builder'
export type SessionStatus = 'lobby' | 'active' | 'completed'
export type MessageType = 'message' | 'system' | 'reflection' | 'artifact'
export type Stage = 1 | 2 | 3 | 4 | 5

export const STAGE_NAMES: Record<Stage, string> = {
  1: 'Meet the Team',
  2: 'Discovery',
  3: 'Documentation',
  4: 'Prompt Building',
  5: 'Wrap-Up',
}

export const STAGE_AGENTS: Record<Stage, AgentName> = {
  1: 'scout',
  2: 'scout',
  3: 'archivist',
  4: 'builder',
  5: 'scout',
}

export const AGENT_COLORS: Record<AgentName, string> = {
  scout: '#d97706',
  archivist: '#115e59',
  builder: '#c65840',
}

export const AGENT_DISPLAY_NAMES: Record<AgentName, string> = {
  scout: 'Scout',
  archivist: 'Archivist',
  builder: 'Builder',
}

export interface SessionMetadata {
  sessionName: string
  password: string
  roomCode: string
  createdAt: Timestamp
  createdBy: string
  creatorUid?: string
  currentStage: Stage
  currentAgent: AgentName
  status: SessionStatus
  teamSize: number
  organizationId?: string
  isReturning?: boolean
  previousSessionIds?: string[]
  returningSummary?: string
  isSolo?: boolean
}

export interface Organization {
  id: string
  name: string
  createdBy: string
  createdAt: Timestamp
  memberUids: string[]
  inviteCode: string
}

export interface OrgMember {
  displayName: string
  email: string
  joinedAt: Timestamp
  role: 'owner' | 'member'
}

export interface Participant {
  id: string
  displayName: string
  joinedAt: Timestamp
  isTyping: boolean
  color: string
}

export interface Message {
  id: string
  participantId: string
  agentName?: AgentName
  displayName: string
  content: string
  type: MessageType
  timestamp: Timestamp
  visible: boolean
  /** True while the server is still appending tokens to this agent message. */
  streaming?: boolean
}

export interface Artifact {
  id: string
  uploadedBy: string
  fileName: string
  content: string
  fileType: string
  wordCount: number
  uploadedAt: Timestamp
}

export interface ReflectionResponse {
  content: string
  submittedAt: Timestamp
}

export interface Reflection {
  id: string
  prompt: string
  stage: Stage
  responses: Record<string, ReflectionResponse>
  allSubmitted: boolean
  synthesisMessageId?: string
}

export interface AgentContext {
  currentSummary: string
  stageHistory: {
    stage: Stage
    agent: AgentName
    summary: string
    completedAt: Timestamp
  }[]
  selectedProcess?: string
  documentsReviewed: string[]
}

export interface Feedback {
  participantId: string
  displayName: string
  overallExperience: string
  workflowBuilt: string
  improvements: string
  recommendRating: number
  additionalFeedback: string
  submittedAt: Timestamp
}

// Participant colors for avatars
export const PARTICIPANT_COLORS = [
  '#ef4444', '#3b82f6', '#10b981', '#8b5cf6',
  '#f59e0b', '#ec4899', '#06b6d4', '#84cc16',
  '#f97316', '#6366f1', '#14b8a6', '#e11d48',
]
